// extracted by mini-css-extract-plugin
export default {"boardSubmission":"style_boardSubmission__hoIdy"};